import CoverageBenefitsByProvider from './CoverageBenefitsByProvider'
export default CoverageBenefitsByProvider
